<template>
    <!--Causes One Start-->
        <section class="causes-one">
            <div class="container">
                <div class="section-title text-center">
                    <!-- <span class="section-title__tagline">Help & donate us now</span> -->
                    <!-- <h2 class="section-title__title">Find the popular cause <br> and donate them</h2> -->
                </div>
                <div class="row">
                    <!--Causes One Single Start-->
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
                        <div class="causes-one__single">
                            <div class="causes-one__img">
                                <img src="assets/images/homeFotos/IMG_3518.jpeg" alt="">
                                <!-- <div class="causes-one__cat">
                                    <p>Education</p>
                                </div> -->
                            </div>
                            <!-- <div class="causes-one__content">
                                <h3 class="causes-one__title"><a href="donation-details.html">Let’s education for
                                        children get good life</a>
                                </h3>
                                <p class="causes-one__text">There are many of lorem, but majori have
                                    suffered alteration in some form.</p>
                                <div class="causes-one__progress">
                                    <div class="causes-one__progress-shape"
                                        style="background-image: url(assets/images/shapes/causes-one-progress-shape-1.png);">
                                    </div>
                                    <div class="bar">
                                        <div class="bar-inner count-bar" data-percent="36%">
                                            <div class="count-text">36%</div>
                                        </div>
                                    </div>
                                    <div class="causes-one__goals">
                                        <p><span>$25,270</span> Raised</p>
                                        <p><span>$30,000</span> Goal</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!--Causes One Single End-->
                    <!--Causes One Single Start-->
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="200ms">
                        <div class="causes-one__single">
                            <div class="causes-one__img">
                                <img src="assets/images/homeFotos/IMG_3528.jpeg" alt="">
                                <!-- <div class="causes-one__cat">
                                    <p>Medical</p>
                                </div> -->
                            </div>
                            <!-- <div class="causes-one__content">
                                <h3 class="causes-one__title"><a href="donation-details.html">It is a long established
                                        fact that a reader</a>
                                </h3>
                                <p class="causes-one__text">There are many of lorem, but majori have
                                    suffered alteration in some form.</p>
                                <div class="causes-one__progress">
                                    <div class="causes-one__progress-shape"
                                        style="background-image: url(assets/images/shapes/causes-one-progress-shape-1.png);">
                                    </div>
                                    <div class="bar">
                                        <div class="bar-inner count-bar" data-percent="36%">
                                            <div class="count-text">36%</div>
                                        </div>
                                    </div>
                                    <div class="causes-one__goals">
                                        <p><span>$25,270</span> Raised</p>
                                        <p><span>$30,000</span> Goal</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!--Causes One Single End-->

                    <!--Causes One Single Start-->
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="300ms">
                        <div class="causes-one__single">
                            <div class="causes-one__img">
                                <img src="assets/images/homeFotos/IMG_5209.jpeg" alt="">
                                <!-- <div class="causes-one__cat">
                                    <p>Food</p>
                                </div> -->
                            </div>
                            <!-- <div class="causes-one__content">
                                <h3 class="causes-one__title"><a href="donation-details.html">There are many variations
                                        of passages</a>
                                </h3>
                                <p class="causes-one__text">There are many of lorem, but majori have
                                    suffered alteration in some form.</p>
                                <div class="causes-one__progress">
                                    <div class="causes-one__progress-shape"
                                        style="background-image: url(assets/images/shapes/causes-one-progress-shape-1.png);">
                                    </div>
                                    <div class="bar">
                                        <div class="bar-inner count-bar" data-percent="36%">
                                            <div class="count-text">36%</div>
                                        </div>
                                    </div>
                                    <div class="causes-one__goals">
                                        <p><span>$25,270</span> Raised</p>
                                        <p><span>$30,000</span> Goal</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!--Causes One Single End-->
                </div>
            </div>
        </section>
        <!--Causes One End-->

</template>
<style>
    .causes-one__img {
        /* Anterior height 500px */
        height: 480px !important;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
    }

    .causes-one {
        padding: 0 0 60px;
    }


    @media only screen and (max-width: 1024px){
        .fadeInUp {
                height: 378px !important;
            } 
            .causes-one__img {
                height: 378px !important;
            }
    }
    
    @media only screen and (max-width: 768px){
            .fadeInUp {
                height: auto !important;
                margin-bottom: 20px;
            } 
            
            .causes-one__img {
                height: auto !important;
                border-bottom-left-radius: 20px;
                border-bottom-right-radius: 20px;
            }
    }

    @media only screen and (max-width: 375px){
        .fadeInUp {
        height: 450px;
        margin-bottom: 20px;
     } 
     
     .causes-one__img {
        height: 450px !important;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
    }

    }

    @media only screen and (max-width: 320px){
        .fadeInUp {
        height: 381px;
        margin-bottom: 20px;
     } 
     
     .causes-one__img {
        height: 381px !important;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
    }

    }

</style>
<script>
</script>